import BMXModal from "../../../../Components/Modals/BMXModal/BMXModal";
import { connectModal } from "redux-modal";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import ServiceCheckListForm from "../../Forms/ServiceForms/ServiceCheckListModalForm/ServiceCheckListModalForm";

const ServiceCheckListModal = (props) => {
  const { t } = useTranslation();
  const [step, setStep] = useState(0);
  const [steps, setSteps] = useState([
    { title: t("global:service.CheckListModal"), error: false },
  ]);

  const { handleHide, show } = props;

  return (
    <BMXModal
      activeStep={step}
      setStep={setStep}
      open={show}
      width={"780px"}
      onClose={handleHide}
      header={props.header}
      steps={steps}
    >
      <ServiceCheckListForm />
    </BMXModal>
  );
};

export default connectModal({ name: "ServiceCheckListModal" })(
  ServiceCheckListModal,
);
